import type { ReactNode } from 'react';
import { Info } from 'lucide-react';

import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';

/** The product's info icon with the explanation in a tooltip, the way Dashboard and Revenue explain their metrics. */
export function InfoTip({ children }: { children: ReactNode }) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Info className="h-3.5 w-3.5 shrink-0 text-muted-foreground/50 hover:text-muted-foreground transition-colors cursor-help" />
      </TooltipTrigger>
      <TooltipContent className="font-normal">{children}</TooltipContent>
    </Tooltip>
  );
}
